// 建議價格是一個聚合出來的數字，光看金額無從判斷競爭力。把它當成一列插進
// 競品排名，使用者才看得出調整後會夾在哪兩家之間。

import moment from "moment";

export const RECOMMEND_ROW_KEY = "__recommend__";
export const STALE_DAYS = 3;

const DAY_IN_MS = 24 * 60 * 60 * 1000;

/**
 * 組出競品排名表格的資料列。
 *
 * 排序規則：
 * 1. 啟用中的飯店與建議價列一起依平均價格由高到低排。
 * 2. 建議價與某家飯店同價時，建議價排在上方 —— 與「往上調」的視覺方向一致。
 * 3. 停用的飯店不參與比較，整批置底，內部同樣依價格由高到低排。
 */
export function buildRankingRows(hotels, recommendprice) {
  const rows = (hotels || []).map((hotel) => ({
    hotel_id: hotel.hotel_id,
    hotel_rank: hotel.hotel_rank,
    averageprice: Number(hotel.averageprice),
    count: hotel.count,
    last_updated_at: hotel.last_updated_at || null,
    details: hotel.details,
    isRecommend: false,
    isSelf: Number(hotel.is_self) === 1,
    isDisabled: Number(hotel.disabled) === 1,
    hotel_name: hotel.hotel_name,
  }));

  const selfHotel = rows.find((row) => row.isSelf);
  const selfName = selfHotel ? selfHotel.hotel_name : "本飯店";

  if (typeof recommendprice === "number" && Number.isFinite(recommendprice)) {
    rows.push({
      hotel_id: RECOMMEND_ROW_KEY,
      hotel_rank: null,
      averageprice: recommendprice,
      count: null,
      last_updated_at: null,
      details: undefined,
      isRecommend: true,
      isSelf: false,
      isDisabled: false,
      hotel_name: selfName,
    });
  }

  const labelled = rows.map((row) => ({
    ...row,
    label: row.isRecommend
      ? `${row.hotel_name} (建議價)`
      : row.isSelf
      ? `${row.hotel_name} (目前)`
      : row.hotel_name,
  }));

  const byPrice = (a, b) => {
    const diff = b.averageprice - a.averageprice;
    if (diff !== 0) return diff;
    if (a.isRecommend) return -1;
    if (b.isRecommend) return 1;
    return 0;
  };

  return labelled
    .filter((row) => !row.isDisabled)
    .sort(byPrice)
    .concat(labelled.filter((row) => row.isDisabled).sort(byPrice));
}

/**
 * 最後更新時間是否舊到不該再當參考。抓取每天跑一次，隔 STALE_DAYS 天
 * 沒更新代表這家已經連續抓取失敗。
 *
 * now 由呼叫端傳入而不是在這裡取現在時間，測試才能固定時間點。
 */
export function isStale(lastUpdatedAt, now) {
  if (!lastUpdatedAt) return false;
  // 後端回傳的是空格分隔的 "YYYY-MM-DD HH:mm:ss"，原生 Date 解析器對這個格式
  // 屬於實作定義行為，部分瀏覽器會回 Invalid Date，NaN 會讓 isStale 靜靜回 false，
  // ⚠ 就無聲消失。moment 對這個格式的解析結果不因瀏覽器而異。
  const updated = moment(lastUpdatedAt).valueOf();
  if (Number.isNaN(updated)) return false;
  return now - updated > STALE_DAYS * DAY_IN_MS;
}
